export default "__VITE_ASSET__C7tVs5$y__"